export default __webpack_public_path__ + "static/media/signup-mobile-2.e1217fab.png";